import { authRequest } from "../utils/netRequest";

export class RideService {
  async ride(ride) {
    return await authRequest({
      url: "/service/ride",
      method: "post",
      data: ride,
    });
  };

  async rideStatus(rideId) {
    return await authRequest({
      url: `/rides/${rideId}/status`,
      method: "get",
    });
  };

  async availability() {
    return await authRequest({
      url: "/service/availability",
      method: "get",
    });
  }

  async book(data) {
    return await authRequest({
      url: "/rides",
      method: "put",
      apiVersion: "v2",
      data,
    });
  };

  async cancellation(rideId) {
    return await authRequest({
      url: `/rides/${rideId}/cancellation-cost`,
      method: "get",
    });
  };

  async cancel(id, reason, comment) {
    return await authRequest({
      url: `/rides/${id}/cancel`,
      method: "put",
      data: {
        ...comment,
        ...reason,
      },
    });
  };

  async getRides(page = 1, limit = 10) {
    const { hasMoreItems, rides } = await authRequest({
      url: `/rides/${page}/${limit}`,
      method: "get",
    });
    //hot fix while BE hasn't right order
    rides.sort((a, b) => b?.puTime - a?.puTime);
    return {
      hasMoreItems,
      rides,
    };
  }

  async getRideDriverPhoto(driverId) {
    const binaryImage = await authRequest({
      url: `/drivers/${driverId}/avatar`,
      method: "get",
      responseType: 'arraybuffer'
    });

    if (binaryImage){
      const image = btoa(String.fromCharCode.apply(null,new Uint8Array(binaryImage)));
      return `data:image/jpg;base64,${image}`;
    }
    return null;
  }
}

export default new RideService();


